var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"main-row"},[_c('span',[_c('span',{staticClass:"mr-4 name text-atlas-blue"},[_vm._v(_vm._s(_vm.item.name))]),_c('span',{staticClass:"mr-4 subtitles"},[_vm._v(_vm._s(_vm.item.email))])]),_c('span',{staticClass:"subtitles"},[_vm._v(_vm._s(_vm.capitalizeText(_vm.item.role)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }